// src/app/services/api.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  reducerPath: "api",
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: (headers, { getState, endpoint }) => {
      const requiresAuth = headers.get("x-requires-auth");

      if (requiresAuth === "true") {
        const token = localStorage.getItem("authToken");
        console.log("request Token", token);
        if (token) {
          headers.set("Authorization", `Bearer ${token}`);
        }
      }

      headers.delete("x-requires-auth");

      return headers;
    },
  }),
  tagTypes: ["Inventory"],
  endpoints: () => ({}),
});
